import type { Workspace } from "./types";
import { workspace as seed } from "../data/seed";

/* Thin data layer. Tries the Penumbrai API first; if it isn't reachable
 * (e.g. running the SPA on its own for a demo), it falls back to the bundled
 * seed workspace so every screen still works. */

const API_BASE = (import.meta.env.VITE_API_URL as string | undefined) || "/api";

async function tryFetch<T>(path: string, timeoutMs = 4000): Promise<T | null> {
  try {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), timeoutMs);
    // `credentials: include` sends the session cookie so the API can resolve the
    // caller's own (tenant-isolated) workspace rather than refusing the request.
    const res = await fetch(`${API_BASE}${path}`, { credentials: "include", signal: ctrl.signal });
    clearTimeout(t);
    if (!res.ok) return null;
    return (await res.json()) as T;
  } catch {
    return null;
  }
}

let cache: Workspace | null = null;

export async function getWorkspace(): Promise<Workspace> {
  if (cache) return cache;
  const remote = await tryFetch<Workspace>("/workspace");
  cache = remote ?? seed;
  return cache;
}

/** Synchronous accessor for the seed, used where async isn't ergonomic. */
export const localWorkspace = seed;
